import { ContentPage } from '@/components/content-page'
import { AccountForm } from '@/components/account-form'

export default function AccountPage() {
  return (
    <ContentPage
      eyebrow="// account"
      title="Your account"
      description="Manage your forum handle and avatar."
    >
      <div className="mx-auto w-full max-w-xl">
        <AccountForm />
      </div>
    </ContentPage>
  )
}
